import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import {SeitenleisteService} from '../../../obs.seitenleiste/seitenleiste.service';
import {Subscription, timer} from 'rxjs';
import {LadeanzeigeService} from '../../../../services/prozesse/ladeanzeige.service';
import {BarrierefreiheitTastenbelegungService} from '../../../obs.barrierefreiheit/services/tastenbelegung.service';

@Component({
  selector: 'app-root',
  templateUrl: './wbp.component.html',
  styleUrls: ['./wbp.component.css'],
})

export class WbpComponent implements OnInit, OnDestroy{
  public navigation = true
  public seitenleiste = true
  public seitenleisteSubscription: Subscription
  private keydownListener: () => void
  public loadingOverlay: boolean = false
  public loadingOverlaySubscription

  constructor(
    private ladeanzeigenService: LadeanzeigeService,
    private seitenleistenService: SeitenleisteService,
    public router: Router,
    private tastenServcie: BarrierefreiheitTastenbelegungService
  ) {
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd){
        if (event.url.match('reset_password') || event.url.match('verify_email')){
          this.navigation = false
        }else{
          this.navigation = true
        }
      }
    })
  }

  ngOnInit() {
    this.seitenleisteSubscription = this.seitenleistenService.zeigeSeitenleiste.subscribe(
      seitenleiste => this.seitenleiste = seitenleiste
    )
    this.loadingOverlaySubscription = this.ladeanzeigenService.ladeAnzeige.subscribe(status => {
      this.loadingOverlay = status;
    })
    this.keydownListener = this.tastenServcie.pruefeTastaturEingabe.bind(this.tastenServcie);
    window.addEventListener('keydown', this.keydownListener);
  }

  ngOnDestroy() {
    this.seitenleisteSubscription.unsubscribe()
    if (this.keydownListener) {
      window.removeEventListener('keydown', this.keydownListener);
    }
  }
}
